<template>
  <v-btn :disabled="disabled"
         :class="helpcenterClass"
         @click="click()">
    <span class="item-name">{{ label }}</span>
    <v-badge
      :value="showBadge"
      color="fin-color-accent-red"
      overlap
      :content="content"
      style="min-width: 18px; height: 18px;"
    >
      <v-icon>{{ icon }}</v-icon>
    </v-badge>
  </v-btn>
</template>

<script>
export default {
  name: 'fin-bottom-navigation-button',
  props: {
    /** The label of the button */
    label: {
      type: String
    },
    /** The icon of the button */
    icon: {
      type: String
    },
    /** Sets if the dot badge should be displayed */
    showBadge: {
      type: Boolean
    },
    /** the class used to link the button to the help center */
    helpcenterClass: {
      type: String
    },
    /** A click function to execute instead of a router link */
    click: {
      type: Function,
      default: null
    },
    content: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
}
</script>

<style scoped lang="scss">
$active-color: $fin-color-primary-dark;
$inactive-color: $fin-color-cool-grey;

.v-btn--active {
  .v-icon:before, .item-name {
    color: $active-color;
  }
}

.v-icon:before, .item-name {
  color: $inactive-color;
}
</style>
